module.exports = __webpack_public_path__ + "static/media/11.8600cc0a.gif";